'use client';

import type { Icon } from '@personly/libs-types';
import { Requirement } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';

import { useTextareas } from '@/providers/textareas';

interface Props {
  errorIcon?: Icon;
}

const TicketTextareaRequirement = ({ errorIcon }: Props) => {
  const { textarea } = useTextareas();
  const { validate, requirement } = useValidators();

  return (
    textarea.length > 0 &&
    !validate('BODY', textarea) && (
      <Requirement icon={errorIcon}>{requirement('BODY')}</Requirement>
    )
  );
};

export default TicketTextareaRequirement;
